import React, { lazy } from "react";

const LazyDataReportSelection = lazy(() => import("./DataReportSelection"));

const DataReportSelection = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode },
) => <LazyDataReportSelection {...props} />;

export default DataReportSelection;
